import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringReplace'
})
export class StringReplacePipe implements PipeTransform {

  transform(value: string, ...replacements: (string | number)[]): string {
    if (!replacements) {
      return value;
    }

    replacements.forEach((replacement, index) => {
      value = value.replace(`{${index}}`, replacement.toString());
    })

    return value;
  }

}
